import { withMenuItem } from "../hocs/withMenuItem";
import { withVersions } from "v2/hocs/withVersions";
import { withSelect } from "../hocs/withSelect";
import BaseSelectItemUIV1 from "./SelectItem/v1";
import BaseSelectItemUIV2 from "./SelectItem/v2";
import BaseSelectItemTypoUIV1 from "./SelectItemTypo/v1";
import BaseSelectItemTypoUIV2 from "./SelectItemTypo/v2";
import BaseSelectUIV1 from "./Select/v1";
import BaseSelectUIV2 from "./Select/v2";

const SelectMenuItem = withVersions({
  v1: BaseSelectItemUIV1,
  v2: BaseSelectItemUIV2,
});

const Select = withVersions({
  v1: withSelect(BaseSelectUIV1, SelectMenuItem, BaseSelectItemTypoUIV1),
  v2: withSelect(BaseSelectUIV2, SelectMenuItem, BaseSelectItemTypoUIV2),
});

export default Select;
